/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

var _regeneratorRuntime = require("@babel/runtime/regenerator");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var d = require("@lexical/html"),
    p = require("@lexical/selection"),
    r = require("@lexical/utils"),
    u = require("lexical");

function z(a) {
  var b = new URLSearchParams();
  b.append("code", a);

  for (var c = 1; c < arguments.length; c++) {
    b.append("v", arguments[c]);
  }

  throw Error("Minified Lexical error #".concat(a, "; visit https://lexical.dev/docs/error?").concat(b, " for the full message or ") + "use the non-minified dev environment for full errors and additional helpful warnings.");
}

var A = "undefined" !== typeof window && "undefined" !== typeof window.document && "undefined" !== typeof window.document.createElement;

function B(a) {
  var b = u.$getSelection();
  if (null == b) throw Error("Expected valid LexicalSelection");
  return u.$isRangeSelection(b) && b.isCollapsed() || 0 === b.getNodes().length ? "" : d.$generateHtmlFromNodes(a, b);
}

function C(a) {
  var b = u.$getSelection();
  if (null == b) throw Error("Expected valid LexicalSelection");
  return u.$isRangeSelection(b) && b.isCollapsed() || 0 === b.getNodes().length ? null : JSON.stringify(D(a, b));
}

function E(a, b, c) {
  (u.DEPRECATED_$isGridSelection(c) || null !== r.$findMatchingParent(c.anchor.getNode(), function (e) {
    return u.DEPRECATED_$isGridCellNode(e);
  }) && null !== r.$findMatchingParent(c.focus.getNode(), function (e) {
    return u.DEPRECATED_$isGridCellNode(e);
  })) && 1 === b.length && u.DEPRECATED_$isGridNode(b[0]) ? F(b, c, !1, a) : I(b, c);
}

function I(a, b) {
  var _a;

  var c = [],
      e = null;

  for (var f = 0; f < a.length; f++) {
    var h = a[f],
        g = u.$isLineBreakNode(h);

    if (g || u.$isDecoratorNode(h) && h.isInline() || u.$isElementNode(h) && h.isInline() || u.$isTextNode(h) || h.isParentRequired()) {
      if (null === e && (e = h.createParentElementNode(), c.push(e), g)) continue;
      null !== e && e.append(h);
    } else c.push(h), e = null;
  }

  u.$isRangeSelection(b) ? b.insertNodes(c) : u.DEPRECATED_$isGridSelection(b) && (a = b.anchor.getNode(), u.DEPRECATED_$isGridCellNode(a) || z(41), (_a = a).append.apply(_a, c));
}

function F(a, b, c, e) {
  1 === a.length && u.DEPRECATED_$isGridNode(a[0]) || z(42);
  var f = a[0];
  a = f.getChildren();
  c = f.getFirstChildOrThrow().getChildrenSize();
  var h = f.getChildrenSize(),
      g = r.$findMatchingParent(b.anchor.getNode(), function (l) {
    return u.DEPRECATED_$isGridCellNode(l);
  });
  b = (f = g && r.$findMatchingParent(g, function (l) {
    return u.DEPRECATED_$isGridRowNode(l);
  })) && r.$findMatchingParent(f, function (l) {
    return u.DEPRECATED_$isGridNode(l);
  });
  u.DEPRECATED_$isGridCellNode(g) && u.DEPRECATED_$isGridRowNode(f) && u.DEPRECATED_$isGridNode(b) || z(43);
  var k = f.getIndexWithinParent(),
      m = Math.min(b.getChildrenSize() - 1, k + h - 1);
  h = g.getIndexWithinParent();
  g = Math.min(f.getChildrenSize() - 1, h + c - 1);
  c = Math.min(h, g);
  f = Math.min(k, m);
  h = Math.max(h, g);
  k = Math.max(k, m);
  m = b.getChildren();
  g = 0;
  var n, q;

  for (var l = f; l <= k; l++) {
    var t = m[l];
    u.DEPRECATED_$isGridRowNode(t) || z(24);
    var y = a[g];
    u.DEPRECATED_$isGridRowNode(y) || z(24);
    t = t.getChildren();
    y = y.getChildren();
    var G = 0;

    var _loop = function _loop(v) {
      var w = t[v];
      u.DEPRECATED_$isGridCellNode(w) || z(25);
      var H = y[G];
      u.DEPRECATED_$isGridCellNode(H) || z(25);
      l === f && v === c ? n = w.getKey() : l === k && v === h && (q = w.getKey());
      var N = w.getChildren();
      H.getChildren().forEach(function (x) {
        u.$isTextNode(x) && u.$createParagraphNode().append(x);
        w.append(x);
      });
      N.forEach(function (x) {
        return x.remove();
      });
      G++;
    };

    for (var v = c; v <= h; v++) {
      _loop(v);
    }

    g++;
  }

  n && q && (a = u.DEPRECATED_$createGridSelection(), a.set(b.getKey(), n, q), u.$setSelection(a), e.dispatchCommand(u.SELECTION_CHANGE_COMMAND, void 0));
}

function J(a, b, c) {
  var e = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var f = null != b ? c.isSelected(b) : !0,
      h = u.$isElementNode(c) && c.excludeFromCopy("html");
  var g = c;

  if (null !== b) {
    var k = p.$cloneWithProperties(c);
    g = k = u.$isTextNode(k) && null != b ? p.$sliceSelectedTextNodeContent(b, k) : k;
  }

  var m = u.$isElementNode(g) ? g.getChildren() : [];
  var n = g;
  k = n.exportJSON();
  var q = n.constructor;
  k.type !== q.getType() && z(58, q.name);
  var t = k.children;
  u.$isElementNode(n) && (Array.isArray(t) || z(59, q.name));
  u.$isTextNode(g) && (g = g.__text, 0 < g.length ? k.text = g : f = !1);

  for (g = 0; g < m.length; g++) {
    n = m[g], q = J(a, b, n, k.children), !f && u.$isElementNode(c) && q && c.extractWithChild(n, b, "clone") && (f = !0);
  }

  if (f && !h) e.push(k);else if (Array.isArray(k.children)) for (a = 0; a < k.children.length; a++) {
    e.push(k.children[a]);
  }
  return f;
}

function D(a, b) {
  var c = [],
      e = u.$getRoot().getChildren();

  for (var f = 0; f < e.length; f++) {
    J(a, b, e[f], c);
  }

  return {
    namespace: a._config.namespace,
    nodes: c
  };
}

function K(a) {
  var b = [];

  for (var c = 0; c < a.length; c++) {
    var e = u.$parseSerializedNode(a[c]);
    u.$isTextNode(e) && p.$addNodeStyle(e);
    b.push(e);
  }

  return b;
}

var L = null;

function M(a, b) {
  var c = A ? (a._window || window).getSelection() : null;
  if (!c) return !1;
  var e = c.anchorNode;
  c = c.focusNode;
  if (null !== e && null !== c && !u.isSelectionWithinEditor(a, e, c)) return !1;
  b.preventDefault();
  b = b.clipboardData;
  e = u.$getSelection();
  if (null === b || null === e) return !1;
  c = B(a);
  a = C(a);
  var f = "";
  null !== e && (f = e.getTextContent());
  null !== c && b.setData("text/html", c);
  null !== a && b.setData("application/x-lexical-editor", a);
  b.setData("text/plain", f);
  return !0;
}

exports.$generateJSONFromSelectedNodes = D;
exports.$generateNodesFromSerializedNodes = K;
exports.$getHtmlContent = B;
exports.$getLexicalContent = C;

exports.$insertDataTransferForPlainText = function (a, b) {
  a = a.getData("text/plain") || a.getData("text/uri-list");
  null != a && b.insertRawText(a);
};

exports.$insertDataTransferForRichText = function (a, b, c) {
  var e = a.getData("application/x-lexical-editor");
  if (e) try {
    var g = JSON.parse(e);

    if (g.namespace === c._config.namespace && Array.isArray(g.nodes)) {
      var k = K(g.nodes);
      return E(c, k, b);
    }
  } catch (_unused) {}
  if (e = a.getData("text/html")) try {
    var f = new DOMParser().parseFromString(e, "text/html"),
        h = d.$generateNodesFromDOM(c, f);
    return E(c, h, b);
  } catch (_unused2) {}
  a = a.getData("text/plain") || a.getData("text/uri-list");
  if (null != a) if (u.$isRangeSelection(b)) for (a = a.split(/(\r?\n|\t)/), c = a.length, f = 0; f < c; f++) {
    h = a[f], "\n" === h || "\r\n" === h ? b.insertParagraph() : "\t" === h ? b.insertNodes([u.$createTabNode()]) : b.insertText(h);
  } else b.insertRawText(a);
};

exports.$insertGeneratedNodes = E;

exports.copyToClipboard = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(a, b) {
    var c, e, f, h;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(null !== L)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", !1);

          case 2:
            if (!(null !== b)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", new Promise(function (g) {
              a.update(function () {
                g(M(a, b));
              });
            }));

          case 4:
            c = a.getRootElement();
            e = null == a._window ? window.document : a._window.document, f = A ? (a._window || window).getSelection() : null;

            if (!(null === c || null === f)) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", !1);

          case 8:
            h = e.createElement("span");
            h.style.cssText = "position: fixed; top: -1000px;";
            h.append(e.createTextNode("#"));
            c.append(h);
            c = new Range();
            c.setStart(h, 0);
            c.setEnd(h, 1);
            f.removeAllRanges();
            f.addRange(c);
            return _context.abrupt("return", new Promise(function (g) {
              var k = a.registerCommand(u.COPY_COMMAND, function (m) {
                r.objectKlassEquals(m, ClipboardEvent) && (k(), null !== L && (window.clearTimeout(L), L = null), g(M(a, m)));
                return !0;
              }, u.COMMAND_PRIORITY_CRITICAL);
              L = window.setTimeout(function () {
                k();
                L = null;
                g(!1);
              }, 50);
              e.execCommand("copy");
              h.remove();
            }));

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();